/**
 * AdminContainer
 * --
 */
import React, { useState, useRef } from 'react';
import AdminPresenter from './AdminPresenter';
import { DEPLOY_TYPE, DOMAIN_URL } from 'utils';
import MessageAlert from 'utils/MessageAlert';
import { useAdminLogin } from 'hooks/AuthHooks';
import { LoadingPage } from 'components';
import { useLocation } from 'react-router-dom';

const defaultAccount = window.localStorage.getItem('jmadmin_account');

const AdminContainer = () => {
  const { loginAdmin } = useAdminLogin();
  /* ===== ROUTE ===== */
  const location = useLocation();
  const queryString = new URLSearchParams(location.search);
  const userTypeRaw = queryString.get('type');
  const userType =
    userTypeRaw === 'shop'
      ? 'SHOP_ADMIN'
      : userTypeRaw === 'store'
      ? 'STORE_ADMIN'
      : 'ADMIN';

  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  const accountRef = useRef(null);
  const passwordRef = useRef(null);
  // 탭키
  // const [tabKey, setTabKey] = useState('ADMIN');
  const [tabKey, setTabKey] = useState(userType);
  // 입력값
  const [inputValue, setInputValue] = useState({
    account: defaultAccount,
    password: '',
  });
  // 로딩
  const [isLoading, setIsLoading] = useState(false);

  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /**
   * 데이터 바인딩 함수
   * --
   * @param {*} t
   * @param {*} v
   * @param {*} callback
   */
  const handleChange = (t, v, callback = null) => {
    let newData = { ...inputValue };
    newData[t] = v;
    const d = {
      ...newData,
    };
    setInputValue(d);

    if (callback) callback(v);
  };

  /**
   * 관리자 로그인
   * --
   */
  const handleSubmit = async (saveId = false) => {
    const { account, password } = inputValue;

    if (!account) {
      accountRef.current.focus();
      MessageAlert.warning('아이디를 입력해주세요');
      return;
    }

    if (!password) {
      passwordRef.current.focus();
      MessageAlert.warning('비밀번호를 입력해주세요');
      return;
    }

    try {
      setIsLoading(true);
      // TODO: 로그인 처리
      const adminValue = {
        admin_account: account,
        password: password,
      };

      const { status, data } = await loginAdmin(adminValue);

      if (status === 200) {
        const { token, account_status, type } = data;

        // NOTE: 로그인한 계정의 타입과 탭키가 다른 경우
        if (type !== tabKey) {
          MessageAlert.warning(
            '로그인에 실패 하였습니다. 계정정보를 확인해주세요.'
          );
          return;
        }

        // NOTE: 활성화(ACTIVE)/비활성화(INACTIVE)/휴면(DORMANT)/탈퇴(WITHDRAWN)
        if (account_status) {
          MessageAlert.warning(
            '로그인에 실패 하였습니다. 관리자에게 문의 해주세요.'
          );
          return;
        }

        // NOTE: 로그인 성공
        if (token) {
          // 아이디 저장
          if (saveId === true) {
            window.localStorage.setItem('jmadmin_account', account);
            window.localStorage.setItem('jmadmin_account_flag', 'true');
          } else {
            window.localStorage.removeItem('jmadmin_account');
            window.localStorage.removeItem('jmadmin_account_flag');
          }
          handleSubRouting(type, token);
        }
      } else {
        MessageAlert.warning('계정정보를 다시 확인해주세요');
      }
    } catch (err) {
      console.log('관리자 로그인 에러', err);
      MessageAlert.error('로그인에 실패 하였습니다. 관리자에게 문의 해주세요.');
      throw err;
    } finally {
      setTimeout(() => {
        setIsLoading(false);
      }, 500);
    }
  };

  /**
   * 관리자 타입별 라우팅 처리
   * @param { string } t
   * @param { string } jwt
   * @returns
   */
  const handleSubRouting = (t, jwt) => {
    let subUrl = '';
    switch (t) {
      case 'ADMIN':
        subUrl = 'admin';
        break;
      case 'STORE_ADMIN':
        subUrl = 'store';
        break;
      case 'SHOP_ADMIN':
        subUrl = 'shop';
        break;
      default:
        subUrl = '';
        break;
    }

    const protocol = window.location.protocol;
    const redirectUrl =
      DEPLOY_TYPE === 'development' ? `${subUrl}-jm-coffee` : subUrl;
    const port = DEPLOY_TYPE === 'local' ? ':3000' : '';
    // const jwtToken = JSON.stringify()

    return (window.location.href = `${protocol}//${redirectUrl}.${DOMAIN_URL}${port}/#/certification?token=${encodeURIComponent(
      jwt
    )}`);
  };

  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      {isLoading && <LoadingPage text={'로그인중입니다.'} />}
      <AdminPresenter
        accountRef={accountRef}
        passwordRef={passwordRef}
        tabKey={tabKey}
        onSelect={setTabKey}
        onSubmit={handleSubmit}
        onChange={handleChange}
        inputValue={setInputValue}
      />
    </>
  );
};

export default AdminContainer;
